import { isCampaignEnabled } from '../../jsCore/config/campaignConfig'
import { register } from '../../components/viewability/viewbilityTracker'
import { trackUserIdentifier } from '../../components/googleAnalyticaSessionTracker/useridentifierTracker'
import { getSite, getPageLocale } from '../../jsCore/application/pageDataObject'

const experimentId = Math.floor(Math.random() * 100)
console.log('experimentId', experimentId)

//iframe version
// const triviaFirstTest = `https://create.playgorithm.com/js/init.js?containerId=playgorithm-unit-678&token=eyJzaXRlSWQiOjE5MCwiZW1iZWRJZCI6Njc4LCJ0b2tlbiI6IiQyeSQxMCR1US5LYVQ2SmZRWWNFTVFCeTJBVW9lWVlwLjR6cFpiaTl6RzdBRjlTS3ZOYWhGVmxVY3ouTyIsInRpbWVzdGFtcCI6MTU1MDQwNjM3M30=&origin=https://frontend.playgorithm.net&customComp=MinuteMedia&className=mm-playgorithm-unit&gtagId=UA-23669758-21&partner=90min_test&uniqkey=playgorithem-monti-id&configName=playgorithem-90min&playlistId=5RhMfyF1&mobileHeight=360px&desktopHeight=460px&shine=1`
// const fotmobTriviaTest = `https://create.playgorithm.com/js/init.js?containerId=playgorithm-unit-678&token=eyJzaXRlSWQiOjE5MCwiZW1iZWRJZCI6Njc4LCJ0b2tlbiI6IiQyeSQxMCR1US5LYVQ2SmZRWWNFTVFCeTJBVW9lWVlwLjR6cFpiaTl6RzdBRjlTS3ZOYWhGVmxVY3ouTyIsInRpbWVzdGFtcCI6MTU1MDQwNjM3M30=&origin=https://frontend.playgorithm.net&lang=${getPageLocale()}&customComp=MinuteMedia&className=mm-playgorithm-unit&gtagId=UA-23669758-21&partner=fotmob&uniqkey=playgorithem-monti-id&configName=playgorithem-fotmob&playlistId=5RhMfyF1&shine=1&mobileHeight=360px&desktopHeight=460px&shine=1`
// const footballAddictTrivia = `https://create.playgorithm.com/js/init.js?containerId=playgorithm-unit-678&token=eyJzaXRlSWQiOjE5MCwiZW1iZWRJZCI6Njc4LCJ0b2tlbiI6IiQyeSQxMCR1US5LYVQ2SmZRWWNFTVFCeTJBVW9lWVlwLjR6cFpiaTl6RzdBRjlTS3ZOYWhGVmxVY3ouTyIsInRpbWVzdGFtcCI6MTU1MDQwNjM3M30=&origin=https://frontend.playgorithm.net&lang=fr&customComp=MinuteMedia&className=mm-playgorithm-unit&gtagId=UA-23669758-21&partner=football_addict&uniqkey=playgorithem-monti-id&configName=playgorithem-football_addict&playlistId=5RhMfyF1&shine=1&&mobileHeight=360px&desktopHeight=460px&videoUnitPath=/175840252/MMPlus/footballaddict/triviawidget/video`

//html version
const triviaSemantic90Min = `https://client.playgorithm.com/latest?containerId=playgorithm-unit-1190&token=eyJzaXRlSWQiOjE5MCwiZW1iZWRJZCI6MTE5MCwidG9rZW4iOiIkMnkkMTAkRlUuMHVGdDN2OHJBVWFcLzc2OXpCTk9nVTJ1QXZZUWNjV2JObU41dFJseWFWQ3liTXNXcFJtIiwidGltZXN0YW1wIjoxNTYxMDM3OTUxfQ==&lang=en&renderMode=html&className=mm-playgorithm-unit&customComp=MinuteMedia&bannerUnitPath=/175840252/90-min/TriviaWidget/Article/300x250&collections=466,1379,465,501,1345,1346&partner=90min&semantic=1&gtagId=UA-23669758-21`

const triviaFirstTest = `https://client.playgorithm.com/latest?containerId=playgorithm-unit-951&token=eyJzaXRlSWQiOjE5MCwiZW1iZWRJZCI6OTUxLCJ0b2tlbiI6IiQyeSQxMCQ2Q21PSy5WcDhnVzNOSlNKbE9RbExlckZmWEpCTXVRU1V0NHFEVGUxVjVcL1NkZkJtVE14ZlMiLCJ0aW1lc3RhbXAiOjE1NTYwMjQ4ODB9&customComp=MinuteMedia&className=mm-playgorithm-unit&gtagId=UA-23669758-21&partner=90min&uniqkey=playgorithem-monti-id&configName=playgorithem-90min&playlistId=5RhMfyF1&inShadow=0&bannerUnitPath=/175840252/90-min/TriviaWidget/Article/300x250&renderMode=html`
const triviaSemanticFotmob = `https://client.playgorithm.com/latest?containerId=playgorithm-unit-1190&token=eyJzaXRlSWQiOjE5MCwiZW1iZWRJZCI6MTE5MCwidG9rZW4iOiIkMnkkMTAkRlUuMHVGdDN2OHJBVWFcLzc2OXpCTk9nVTJ1QXZZUWNjV2JObU41dFJseWFWQ3liTXNXcFJtIiwidGltZXN0YW1wIjoxNTYxMDM3OTUxfQ==&lang=${getPageLocale()}&renderMode=html&className=mm-playgorithm-unit&customComp=MinuteMedia&bannerUnitPath=/175840252/MMPlus/Fotmob/TriviaWidget/300x250&collections=466,1379,465,501,1345,1346&partner=fotmob&semantic=1&gtagId=UA-23669758-21&shouldRenderAdBetweenQuestions=2,4,6`

const fotmobTriviaTest = `https://client.playgorithm.com/latest?containerId=playgorithm-unit-951&token=eyJzaXRlSWQiOjE5MCwiZW1iZWRJZCI6OTUxLCJ0b2tlbiI6IiQyeSQxMCQ2Q21PSy5WcDhnVzNOSlNKbE9RbExlckZmWEpCTXVRU1V0NHFEVGUxVjVcL1NkZkJtVE14ZlMiLCJ0aW1lc3RhbXAiOjE1NTYwMjQ4ODB9&lang=${getPageLocale()}&customComp=MinuteMedia&className=mm-playgorithm-unit&gtagId=UA-23669758-21&partner=fotmob&uniqkey=playgorithem-monti-id&configName=playgorithem-fotmob&playlistId=5RhMfyF1&inShadow=0&bannerUnitPath=/175840252/MMPlus/Fotmob/TriviaWidget/300x250&renderMode=html`
const footballAddictTrivia = `https://client.playgorithm.com/latest?containerId=playgorithm-unit-951&token=eyJzaXRlSWQiOjE5MCwiZW1iZWRJZCI6OTUxLCJ0b2tlbiI6IiQyeSQxMCQ2Q21PSy5WcDhnVzNOSlNKbE9RbExlckZmWEpCTXVRU1V0NHFEVGUxVjVcL1NkZkJtVE14ZlMiLCJ0aW1lc3RhbXAiOjE1NTYwMjQ4ODB9&lang=fr&customComp=MinuteMedia&className=mm-playgorithm-unit&gtagId=UA-23669758-21&partner=football_addict&uniqkey=playgorithem-monti-id&configName=playgorithem-football_addict&playlistId=5RhMfyF1&videoUnitPath=/175840252/MMPlus/footballaddict/triviawidget/video`

const triviaGermanSite = `https://create.playgorithm.com/js/init.js?containerId=playgorithm-unit-693&token=eyJzaXRlSWQiOjE5MCwiZW1iZWRJZCI6NjkzLCJ0b2tlbiI6IiQyeSQxMCRFcW1cL25mck9aWFZnMzBjWTVzTjI5TzVhSC50OC56cEdielZYXC9udWN2MXptTG5JTkc4NWouIiwidGltZXN0YW1wIjoxNTUwNTA0NTMwfQ==&origin=https://frontend.playgorithm.net&lang=de&customComp=MinuteMedia&className=mm-playgorithm-unit&gtagId=UA-23669758-21&partner=90min_de&uniqkey=playgorithem-monti-id&configName=playgorithem-90min_d2&playlistId=5RhMfyF1&userIdentifier=${experimentId}&position=2&shine=1&shouldLoadVideo=1&mobileHeight=360px&desktopHeight=460px&bannerUnitPath=/175840252/90min.de/triviawidget/article/300x250`

const snapStories =
  'https://firebasestorage.googleapis.com/v0/b/snappd-6be54.appspot.com/o/widget%2Farchive-widget%2FGaDALxOKnfgvLOo4zB7BLgcLpxC3.js?alt=media&token=snappd-widget-cloud-new&partner=90min'
// 'https://firebasestorage.googleapis.com/v0/b/snappd-6be54.appspot.com/o/widget%2Farchive-widget%2FGaDALxOKnfgvLOo4zB7BLgcLpxC3.js?alt=media&token=snappd-widget-cloud-new&partner=90min'
const triviaFloor8 = `https://create.playgorithm.com/js/init.js?containerId=playgorithm-unit-869&token=eyJzaXRlSWQiOjE5MCwiZW1iZWRJZCI6ODY5LCJ0b2tlbiI6IiQyeSQxMCRuSDA5S3l1em9tZE9nVVlrclpsTnRlUTdCU1lLMWpjdU5iTjltTmw1RnB4aldOekNQTnY1MiIsInRpbWVzdGFtcCI6MTU1MzEwNzIzOX0=&origin=https://frontend.playgorithm.net&customComp=MinuteMedia&className=mm-playgorithm-unit&gtagId=UA-23669758-21&partner=floor8_test&uniqkey=playgorithem-monti-id&configName=playgorithem-floor8&playlistId=5RhMfyF1&userIdentifier=${experimentId}&position=2&shouldLoadVideo=1&&mobileHeight=360px&desktopHeight=460px&shine=1`

const deepHeadToHeadFotmob =
  'https://cdn.deep.it/article/embed.js?containerId=deepHeadToHead&widgetTypes=Quiz&widgetParams=PARTNER%3Dfotmob%26configName%3DheadToHead-fotmob'

const deepHeadToHeadFotmobStartScreen =
  'https://cdn.deep.it/article/embed.js?containerId=deepHeadToHead&widgetTypes=Quiz&widgetParams=PARTNER%3Dfotmob%26configName%3DheadToHead-fotmob%26autoStart%3Dtrue'

const deepHeadToHead90min =
  'https://cdn.deep.it/article/embed.js?containerId=deepHeadToHead&widgetTypes=Quiz&widgetParams=PARTNER%3D90min%26configName%3DheadToHead-fotmob'

const deepHeadToHead90minFr =
  'https://cdn.deep.it/article/embed.js?containerId=deepHeadToHead&widgetTypes=Quiz&languageCode=fr&widgetParams=PARTNER%3D90min%26configName%3DheadToHead-fotmob'

const deepHeadToHead12upMlb =
  'https://cdn.deep.it/article/embed.js?containerId=deepHeadToHead&widgetTypes=Quiz&domain=Baseball&widgetParams=PARTNER%3D12up'

const deepHeadToHead90minStartScreen =
  'https://cdn.deep.it/article/embed.js?containerId=deepHeadToHead&widgetTypes=Quiz&autoStart=truewidgetParams=PARTNER%3D90min%26configName%3DheadToHead-fotmob%26autoStart%3Dtrue'

const deepHeadToHeadStatic =
  'https://cdn.deep.it/script-embed/all.js?type=SoccerQuiz&containerId=deepHeadToHead&cache=true&query=89260180-7181-11e9-a8df-e724252272e2&languageCode=en&customer=90min&partner=90min'

const deepHeadToHead =
  'https://cdn.deep.it/article/embed.js?containerId=deepHeadToHead&widgetTypes=Quiz&widgetParams=PARTNER%3D90min'

const deepHeadToHeadFloor8 =
  'https://cdn.deep.it/script-embed/all.js?type=SoccerQuiz&containerId=deepHeadToHead&cache=true&query=1&languageCode=en&customer=floor8&partner=floor8&widgetParams=PARTNER%3Dfloor8'

const trinityOriginalDesign = `https://trinitymedia.ai/sas/player/trinity.php?sCampaignID=1604966975&language=${getPageLocale()}&partner=12up&gaAccountId=UA-23669758-21&abtest=original`
const trinityNewDesign = `https://trinitymedia.ai/sas/player/trinity.php?sCampaignID=1604966975&language=${getPageLocale()}&partner=12up&gaAccountId=UA-23669758-21&abtest=90minorange&FAB=t`

const preMtachFr = `https://client.playgorithm.com/latest?renderMode=html&containerId=playgorithm-unit-1382&token=eyJzaXRlSWQiOjE5MCwiZW1iZWRJZCI6MTM4MiwidG9rZW4iOiIkMnkkMTAkQ01iNjR5ZFlNR0JOLjhpbC5Nd3ZodWZ5djk2amE4MHVKcUNDOExWVjRUUDAuVVExUll5Ny4iLCJ0aW1lc3RhbXAiOjE1NjgxMDcxMzZ9&lang=fr&className=mm-playgorithm-unit&customComp=MinuteMedia&partner=90min_fr&bannerUnitPath=/175840252/90-min/Playgorithm/PreMatchWidget/MultiSize&gtagId=UA-23669758-21&bannerAfterEveryIndex=2`
var isParagraphArray = []

const FACTS_CAMPAIGNS = {
  en: 'https://facts-generator.mmwidgets.com/facts/lla-lorona/',
  es: 'https://facts-generator.mmwidgets.com/facts/lla-lorona-es/',
  'pt-BR': 'https://facts-generator.mmwidgets.com/facts/lla-lorona-pt/',
  it: 'https://facts-generator.mmwidgets.com/facts/lla-lorona-it/',
  tr: 'https://facts-generator.mmwidgets.com/facts/lla-lorona-2-tr/',
}

const MOTW_CAMPAIGNS = {
  en: 'https://movers-of-the-week.mmwidgets.com/motw/week-1/',
}

function getABTestExperimentValue(
  minRangeExperimentA,
  maxRangeExperimentA,
  minRangeExperimentB,
  maxRangeExperimentB,
  experimentA,
  experimentB
) {
  if (minRangeExperimentA <= experimentId && maxRangeExperimentA >= experimentId) {
    return experimentA
  }
  if (minRangeExperimentB <= experimentId && maxRangeExperimentB >= experimentId) {
    return experimentB
  }
  return null
}

function isBoldTitle(node) {
  return node.match(`<strong>.+<\\/strong>`) !== null
}

function isParagraph(node) {
  return (
    node.innerText !== '' &&
    node.innerHTML !== '<span style="font-size: 1em;"><br></span>' &&
    node.innerHTML !== '<strong><br></strong>' &&
    !isBoldTitle(node.innerHTML) &&
    node.innerHTML !== '&nbsp;'
  )
}

function setParagraphMap() {
  let postItems = [...document.querySelectorAll('.post-content > *')]
  isParagraphArray = postItems.map((x, index) => isParagraph(x))
}

setParagraphMap()

function getStartPoint() {
  return parseInt(isParagraphArray.length / 2 - 1)
}

function isPositionValidForCampaign(index) {
  return isParagraphArray[index] && isParagraphArray[index + 1]
}

function findPositionToInjectCampaign() {
  if (isParagraphArray.length < 6) return -1
  for (let i = getStartPoint(); i < isParagraphArray.length - 2; i++) {
    if (isPositionValidForCampaign(i)) {
      return i
    }
  }
  return -1
}

function shouldLoadWidgetByRequest(param) {
  return window.location.search.includes(param)
}

const ios = () => {
  return navigator.userAgent.indexOf('like Mac') !== -1
}

const safari = () => {
  return navigator.userAgent.indexOf('AppleWebKit') !== -1
}

const iosAndSafari = () => ios() && safari()

const isIosInAppBrowser = () => iosAndSafari() && navigator.userAgent.indexOf('Safari') === -1

function shouldLoadVideoInNativeApp() {
  return window.location.search.includes('app=1&ref=Android') ? 1 : 0
}

function findEndOfArticle() {
  return document.querySelectorAll('.post-content > *').length
}

function getLongScrollScript() {
  return window.location.search.includes('app=1&ref=Android')
    ? 'https://bucket1.mm-syringe.com/prod/configs/widget-90min-transfers-longscroll.js'
    : 'https://bucket1.mm-syringe.com/prod/configs/widget-90min-transfers-longscroll-no-video.js'
}

const PLAYGORITHM_90_MIN = {
  pageTypes: ['post'],
  isEmbedded: false,
  daysWhiteList: [0, 1, 2, 3, 4, 5, 6],
  isSlideshow: false,
  featureId: 'Fresh8',
  blacklistedCategories: ['sponsored', 'no-campaign-manager'],
  placeHolder: 'playgorithmPlaceHolder',
  name: 'playgorithm-unit-1190',
  id: 'playgorithm-unit-1190',
  position: findPositionToInjectCampaign(),
  listPosition: 2,
  src: triviaSemantic90Min,
  embedPartners: ['app=1'],
  blacklistedPosts: [6427004],
  locales: ['en'],
  site: '90min',
  injectPosition: 'afterEnd',
  shouldRenderVideoStick: shouldLoadVideoInNativeApp(),
  shouldAddDataAttrToScriptTag: false,
  videoConfig: 'https://www.oo-syringe.com/prod/configs/fc985619-cf42-9fa3-3133-4132653b9f51.js',
  isSponsoredPost: false,
  videoWrraperMargin: '-8px',
  videoWrraperMaxWidth: '600px',
  shouldLoadSyringe: false,
}

const PLAYGORITHM_PRE_MATCH_90_MIN_FR = {
  pageTypes: ['post'],
  isEmbedded: false,
  daysWhiteList: [0, 1, 2, 3, 4, 5, 6],
  isSlideshow: false,
  featureId: 'Fresh8',
  blacklistedCategories: ['sponsored', 'no-campaign-manager'],
  placeHolder: 'playgorithmPlaceHolder',
  name: 'playgorithm-unit-1382',
  id: 'playgorithm-unit-1382',
  position: findPositionToInjectCampaign(),
  listPosition: 2,
  src: preMtachFr,
  blacklistedPosts: [6427004],
  locales: ['fr'],
  site: '90min',
  injectPosition: 'afterEnd',
  shouldRenderVideoStick: false,
  shouldAddDataAttrToScriptTag: false,
  videoConfig: 'https://www.oo-syringe.com/prod/configs/fc985619-cf42-9fa3-3133-4132653b9f51.js',
  isSponsoredPost: false,
  videoWrraperMargin: '-8px',
  videoWrraperMaxWidth: '600px',
  shouldLoadSyringe: false,
  whiteListCountryCodes: ['IL', 'FR'],
}

const PLAYGORITHM_90_MIN_APP_LONGSCROLL_TRANSFERS = {
  pageTypes: ['post'],
  isEmbedded: false,
  daysWhiteList: [0, 1, 2, 3, 4, 5, 6],
  isSlideshow: false,
  featureId: 'Fresh8',
  blacklistedCategories: ['sponsored', 'no-campaign-manager'],
  placeHolder: 'playgorithmPlaceHolder',
  name: 'longScroll',
  id: 'mmWidget',
  position: findEndOfArticle(),
  listPosition: 2,
  src: getLongScrollScript(),
  embedPartners: ['app=1'],
  whitelistedPosts: [6427004],
  locales: ['en'],
  site: '90min',
  injectPosition: 'afterEnd',
  shouldRenderVideoStick: false,
  shouldAddDataAttrToScriptTag: false,
  isSponsoredPost: false,
  // videoWrraperMargin: '-8px',
  // videoWrraperMaxWidth: '600px',
  shouldLoadSyringe: true,
}

const FACTS_90_MIN = {
  pageTypes: ['post'],
  isEmbedded: false,
  daysWhiteList: [0, 1, 2, 3, 4, 5, 6],
  isSlideshow: false,
  featureId: 'Fresh8',
  placeHolder: 'facts-size',
  id: 'facts',
  position: 0,
  listPosition: 2,
  src: triviaFirstTest,
  whitelistedPosts: [6341777, 6341785, 6341791, 6341792, 6341794],
  locales: ['en', 'es', 'pt-BR', 'it', 'tr'],
  site: '90min',
  injectPosition: 'beforeBegin',
  shouldRenderVideoStick: false,
  isSponsoredPost: true,
  shouldLoadSyringe: false,
}

const MOTW_90_MIN = {
  pageTypes: ['post'],
  isEmbedded: false,
  daysWhiteList: [0, 1, 2, 3, 4, 5, 6],
  isSlideshow: false,
  featureId: 'Fresh8',
  placeHolder: 'motw-size',
  id: 'motw',
  position: 0,
  listPosition: 2,
  src: triviaFirstTest,
  whitelistedPosts: [6353539],
  locales: ['en'],
  site: '90min',
  injectPosition: 'beforeBegin',
  shouldRenderVideoStick: false,
  isSponsoredPost: true,
  shouldLoadSyringe: false,
}

const PLAYGORITHM_FOTMOB_EN = {
  pageTypes: ['post'],
  isEmbedded: true,
  daysWhiteList: [0, 1, 2, 3, 4, 5, 6],
  isSlideshow: false,
  featureId: 'Fresh8',
  placeHolder: 'playgorithmPlaceHolder',
  name: 'playgorithm-unit-1190',
  id: 'playgorithm-unit-1190',
  src: triviaSemanticFotmob,
  embedPartners: ['utm_source=fotmob&utm_medium=api'],
  excludeByUrl: ['noAds'],
  position: findPositionToInjectCampaign(),
  listPosition: 2,
  locales: ['en'],
  site: '90min',
  injectPosition: 'afterEnd',
  shouldRenderVideoStick: true,
  shouldAddDataAttrToScriptTag: false,
  videoConfig:
    'https://bucket1.mm-syringe.com/prod/configs/dca22f49-7426-c4e3-c13a-6eadd2c378bf.js',
  isSponsoredPost: false,
  videoWrraperMargin: '-8px',
  videoWrraperMaxWidth: '600px',
  shouldLoadSyringe: false,
}

const HEAD_TO_HEAD_FOTMOB_EN = {
  pageTypes: ['post'],
  isEmbedded: true,
  daysWhiteList: [0, 1, 2, 3, 4, 5, 6],
  isSlideshow: false,
  featureId: 'Fresh8',
  blacklistedCategories: ['sponsored'],
  placeHolder: 'deepHeadTOHeadPlaceHolder',
  id: 'deepHeadToHead',
  position: findPositionToInjectCampaign(),
  listPosition: 2,
  src: deepHeadToHeadFotmob,
  embedPartners: ['utm_source=fotmob&utm_medium=api'],
  locales: ['en'],
  site: '90min',
  name: 'deep_head_to_head',
  injectPosition: 'afterEnd',
  shouldRenderVideoStick: true,
  shouldAddDataAttrToScriptTag: false,
  videoConfig:
    'https://bucket1.mm-syringe.com/prod/configs/62ee505b-bdbc-8979-fa31-1906d46860a4.js',
  isSponsoredPost: false,
  videoWrraperMargin: '0px',
  videoWrraperMaxWidth: '600px',
  shouldLoadSyringe: false,
}

const HEAD_TO_HEAD_90MIN_EN = {
  pageTypes: ['post'],
  isEmbedded: false,
  daysWhiteList: [0, 1, 2, 3, 4, 5, 6],
  isSlideshow: false,
  featureId: 'Fresh8',
  blacklistedCategories: ['sponsored'],
  placeHolder: 'deepHeadTOHeadPlaceHolder',
  id: 'deepHeadToHead',
  blacklistedPosts: [6427004, 5342660, 39],
  position: findPositionToInjectCampaign(),
  listPosition: 2,
  src: deepHeadToHead90min,
  embedPartners: ['app=1'],
  locales: ['en'],
  site: '90min',
  name: 'deep_head_to_head',
  injectPosition: 'afterEnd',
  shouldRenderVideoStick: shouldLoadVideoInNativeApp(),
  shouldAddDataAttrToScriptTag: false,
  videoConfig:
    'https://bucket1.mm-syringe.com/prod/configs/280cce64-64e0-9dfb-d8c1-81855ae53573.js',
  isSponsoredPost: false,
  videoWrraperMargin: '0px',
  videoWrraperMaxWidth: '600px',
  shouldLoadSyringe: false,
}

const HEAD_TO_HEAD_90MIN_FR = {
  pageTypes: ['post'],
  isEmbedded: false,
  daysWhiteList: [0, 1, 2, 3, 4, 5, 6],
  isSlideshow: false,
  featureId: 'Fresh8',
  blacklistedCategories: ['sponsored'],
  placeHolder: 'deepHeadTOHeadPlaceHolder',
  id: 'deepHeadToHead',
  blacklistedPosts: [6427004],
  position: findPositionToInjectCampaign(),
  whiteListCountryCodes: ['IL'],
  listPosition: 2,
  src: deepHeadToHead90minFr,
  locales: ['fr'],
  site: '90min',
  name: 'deep_head_to_head',
  injectPosition: 'afterEnd',
  shouldRenderVideoStick: false,
  shouldAddDataAttrToScriptTag: false,
  videoConfig:
    'https://bucket1.mm-syringe.com/prod/configs/280cce64-64e0-9dfb-d8c1-81855ae53573.js',
  isSponsoredPost: false,
  videoWrraperMargin: '0px',
  videoWrraperMaxWidth: '600px',
  shouldLoadSyringe: false,
}

const HEAD_TO_HEAD_12UP_MLB_EN = {
  pageTypes: ['post'],
  isEmbedded: false,
  daysWhiteList: [0, 1, 2, 3, 4, 5, 6],
  isSlideshow: false,
  featureId: 'Fresh8',
  blacklistedCategories: ['sponsored'],
  placeHolder: 'deepHeadTOHeadPlaceHolder',
  id: 'deepHeadToHead',
  blacklistedPosts: [6427004],
  position: findPositionToInjectCampaign(),
  listPosition: 2,
  src: shouldLoadWidgetByRequest('deepMlb') ? deepHeadToHead12upMlb : '',
  locales: ['en'],
  site: '12up',
  name: 'deep_head_to_head',
  injectPosition: 'afterEnd',
  shouldRenderVideoStick: false,
  shouldAddDataAttrToScriptTag: false,
  videoConfig:
    'https://bucket1.mm-syringe.com/prod/configs/280cce64-64e0-9dfb-d8c1-81855ae53573.js',
  isSponsoredPost: false,
  videoWrraperMargin: '0px',
  videoWrraperMaxWidth: '600px',
  shouldLoadSyringe: false,
}

const PLAYGORITHM_FOTMOB_IT = {
  pageTypes: ['post'],
  isEmbedded: true,
  daysWhiteList: [0, 1, 2, 3, 4, 5, 6],
  isSlideshow: false,
  featureId: 'Fresh8',
  placeHolder: 'playgorithmPlaceHolder',
  name: 'playgorithm-unit-951',
  id: 'playgorithm-unit-951',
  src: fotmobTriviaTest,
  embedPartners: ['utm_source=fotmob&utm_medium=api'],
  excludeByUrl: ['noAds'],
  position: findPositionToInjectCampaign(),
  locales: ['it'],
  site: '90min',
  injectPosition: 'afterEnd',
  shouldRenderVideoStick: true,
  isSponsoredPost: false,
  shouldAddDataAttrToScriptTag: false,
  videoConfig:
    'https://bucket1.mm-syringe.com/prod/configs/c6c3c515-2806-e065-65b6-21421ee2d998.js',
  videoWrraperMargin: '-8px',
  videoWrraperMaxWidth: '600px',
  shouldLoadSyringe: false,
}

const PLAYGORITHM_FOTMOB_DE = {
  pageTypes: ['post'],
  isEmbedded: true,
  daysWhiteList: [0, 1, 2, 3, 4, 5, 6],
  isSlideshow: false,
  featureId: 'Fresh8',
  placeHolder: 'playgorithmPlaceHolder',
  name: 'playgorithm-unit-951',
  id: 'playgorithm-unit-951',
  src: fotmobTriviaTest,
  embedPartners: ['utm_source=fotmob&utm_medium=api'],
  excludeByUrl: ['noAds'],
  position: findPositionToInjectCampaign(),
  locales: ['de'],
  site: '90min',
  injectPosition: 'afterEnd',
  isSponsoredPost: false,
  shouldRenderVideoStick: true,
  shouldAddDataAttrToScriptTag: false,
  videoConfig:
    'https://bucket1.mm-syringe.com/prod/configs/48c18dd8-795c-2ed7-b176-9aa8d634e8a7.js',
  videoWrraperMargin: '-8px',
  videoWrraperMaxWidth: '600px',
  shouldLoadSyringe: false,
}

const PLAYGORITHM_FOTMOB_ES = {
  pageTypes: ['post'],
  isEmbedded: true,
  daysWhiteList: [0, 1, 2, 3, 4, 5, 6],
  isSlideshow: false,
  featureId: 'Fresh8',
  placeHolder: 'playgorithmPlaceHolder',
  name: 'playgorithm-unit-951',
  id: 'playgorithm-unit-951',
  src: fotmobTriviaTest,
  embedPartners: ['utm_source=fotmob&utm_medium=api'],
  excludeByUrl: ['noAds'],
  position: findPositionToInjectCampaign(),
  locales: ['es'],
  site: '90min',
  injectPosition: 'afterEnd',
  isSponsoredPost: false,
  shouldRenderVideoStick: true,
  shouldAddDataAttrToScriptTag: false,
  videoConfig:
    'https://bucket1.mm-syringe.com/prod/configs/609d9aa1-daff-5bac-5fef-efde23cca7ca.js',
  videoWrraperMargin: '-8px',
  videoWrraperMaxWidth: '600px',
  shouldLoadSyringe: false,
}

const SNAP_90MIN = {
  pageTypes: ['post'],
  isEmbedded: false,
  daysWhiteList: [0, 1, 2, 3, 4, 5, 6],
  isSlideshow: false,
  featureId: 'Fresh8',
  blacklistedCategories: ['sponsored'],
  whitelistedCategories: [],
  placeHolder: 'GaDALxOKnfgvLOo4zB7BLgcLpxC3',
  id: 'snappdEmbedWidget',
  src: snapStories,
  blacklistedPosts: [6242836, 6296514, 6296514, 6296515, 6296517, 6296519, 6296521, 6296525],
  whiteListCountryCodes: ['IN', 'NG', 'MY', 'TH', 'ID', 'CA', 'GH'],
  position: findPositionToInjectCampaign(),
  listPosition: 2,
  excludeByUrl: ['app=1'],
  dataAttr: [
    `data-snappdwidget="GaDALxOKnfgvLOo4zB7BLgcLpxC3"`,
    `data-shape="rectangle"`,
    `data-border="ff9900"`,
    `data-hover="de8808"`,
    `data-size="default"`,
    `data-hideavatar="1"`,
  ],
  locales: ['en'],
  site: '90min',
  injectPosition: 'afterEnd',
  shouldRenderVideoStick: false,
  isSponsoredPost: false,
  shouldLoadSyringe: false,
}

const PLAYGORITHM_FLOOR_8 = {
  pageTypes: ['post'],
  isEmbedded: false,
  whiteListCountryCodes: ['US', 'IL'],
  daysWhiteList: [0, 1, 2, 3, 4, 5, 6],
  isSlideshow: false,
  featureId: 'Fresh8',
  blacklistedCategories: ['sponsored', 'no-campaign-manager'],
  placeHolder: 'playgorithmPlaceHolder',
  id: 'playgorithm-unit-869',
  name: 'playgorithm-unit-869',
  position: findPositionToInjectCampaign(),
  listPosition: 2,
  src: shouldLoadWidgetByRequest('trivia')
    ? triviaFloor8
    : getABTestExperimentValue(1, 20, 21, 40, triviaFloor8, triviaFloor8),
  locales: ['en'],
  site: 'floor8',
  injectPosition: 'afterEnd',
  shouldRenderVideoStick: false,
  isSponsoredPost: false,
  shouldLoadSyringe: false,
}

const DEEP_HEAD_TO_HEAD_WIDGET_FLOOR8 = {
  pageTypes: ['post'],
  isEmbedded: false,
  daysWhiteList: [0, 1, 2, 3, 4, 5, 6],
  isSlideshow: false,
  featureId: 'Fresh8',
  blacklistedCategories: ['sponsored'],
  placeHolder: 'deepHeadTOHeadPlaceHolder',
  id: 'deepHeadToHead',
  position: 2,
  listPosition: 2,
  src: deepHeadToHeadFloor8,
  whitelistedPosts: [20023, 20030, 20059, 20064, 20097],
  locales: ['en'],
  site: 'floor8',
  name: 'deep_head_to_head',
  injectPosition: 'afterEnd',
  shouldRenderVideoStick: false,
  shouldAddDataAttrToScriptTag: false,
  isSponsoredPost: false,
  shouldLoadSyringe: false,
}

const SPORTRADAR_FACTIVES_90MIN = {
  pageTypes: ['post'],
  isEmbedded: false,
  daysWhiteList: [0, 1, 2, 3, 4, 5, 6],
  isSlideshow: false,
  featureId: 'Fresh8',
  blacklistedCategories: ['sponsored', 'no-campaign-manager'],
  placeHolder: 'FactivePlaceHolder',
  id: 'inhabit',
  name: 'inhabit',
  position: findPositionToInjectCampaign(),
  listPosition: 2,
  injectPosition: 'afterEnd',
  src: `https://inhabit-service.cdn.arkadiumhosted.com/Widget/v1/`,
  locales: ['en'],
  dataAttr: [`data-ark-client="71c49787-8f2b-4801-b9d7-7f5879a1460d"`],
  site: '90min',
  embedPartners: ['app=1'],
  shouldRenderVideoStick: shouldLoadVideoInNativeApp(),
  shouldAddDataAttrToScriptTag: true,
  publisherDescriptionForGa: '90min',
  shouldAddSpecificPlaceHolder: true,
  specificPlaceHolder: `<ark-box data-ark-client='71c49787-8f2b-4801-b9d7-7f5879a1460d'></ark-box>`,
  videoConfig: 'https://www.oo-syringe.com/prod/configs/b69967cd-26a0-3865-dfbb-15a5da776ad1.js',
  isSponsoredPost: false,
  videoWrraperMargin: '0px',
  videoWrraperMaxWidth: '100%',
  shouldLoadSyringe: false,
}

const TRINITY_12UP = {
  pageTypes: ['post'],
  isEmbedded: false,
  daysWhiteList: [0, 1, 2, 3, 4, 5, 6],
  isSlideshow: false,
  featureId: 'Fresh8',
  blacklistedCategories: ['sponsored', 'no-campaign-manager'],
  placeHolder: 'trinityAudioPlaceholder',
  id: 'trinity',
  name: 'trinityAudioPlaceholder',
  position: 0,
  listPosition: 0,
  src: shouldLoadWidgetByRequest('trinity')
    ? trinityNewDesign
    : getABTestExperimentValue(1, 33, 34, 100, trinityNewDesign, ''),
  locales: ['en', 'es'],
  site: '12up',
  injectPosition: 'beforebegin',
  shouldRenderVideoStick: false,
  shouldAddDataAttrToScriptTag: false,
  publisherDescriptionForGa: '12up',
  shouldAddSpecificPlaceHolder: false,
  isSponsoredPost: false,
  shouldLoadSyringe: false,
}

var campaigns = [
  PLAYGORITHM_FOTMOB_IT,
  PLAYGORITHM_FOTMOB_DE,
  PLAYGORITHM_FOTMOB_ES,
  FACTS_90_MIN,
  MOTW_90_MIN,
  TRINITY_12UP,
  PLAYGORITHM_PRE_MATCH_90_MIN_FR,
  HEAD_TO_HEAD_12UP_MLB_EN,
  SNAP_90MIN,
]

let fotmobSplitMarketplace = getABTestExperimentValue(
  0,
  50,
  51,
  100,
  PLAYGORITHM_FOTMOB_EN,
  HEAD_TO_HEAD_FOTMOB_EN
)

let nintiMinSplitMarketplace = getABTestExperimentValue(
  0,
  50,
  51,
  100,
  HEAD_TO_HEAD_90MIN_EN,
  SPORTRADAR_FACTIVES_90MIN
)

campaigns.push(fotmobSplitMarketplace)
campaigns.push(nintiMinSplitMarketplace)

function renderDataAttr(campaign) {
  if (campaign.dataAttr) {
    let attrStr = ''
    campaign.dataAttr.forEach(attr => {
      attrStr += attr
    })
    return attrStr
  }
  return null
}

function getFactsSrc(campaign) {
  return campaign.id === 'facts'
    ? FACTS_CAMPAIGNS[getPageLocale()]
    : MOTW_CAMPAIGNS[getPageLocale()]
}

function renderVideoStickToWidget(campaign) {
  return campaign.shouldRenderVideoStick
    ? `<div class="videoWraaperMarketPlace" style='margin-top:${campaign.videoWrraperMargin};max-width:${campaign.videoWrraperMaxWidth};background-color:black;display:none;flex-direction: row;'>
        <style>.montiPlaceHolderApp>div {margin: 0}</style>
        <div class='montiPlaceHolderApp' style='width:50%;padding-top:calc(100%/16/9);transform: translateY(-1px)'></div>
        <div style='color:white;width:50%;padding-left:14px;display: flex;justify-content:center;flex-direction:column;'>
            <div>This Week</div>
            <div style='font-size:16px;font-weight: 700'>MUST WATCH</div>
         </div>
        </div>`
    : ''
}

function addPlaceHolder(campaign) {
  let paragraph = document.querySelectorAll('.post-content > p')[campaign.position]
  if (paragraph === undefined) {
    paragraph = document.getElementsByClassName('text fragment')[campaign.listPosition]
  }
  if (paragraph === undefined) {
    paragraph = document.querySelectorAll('.post-content > p')[
      document.querySelectorAll('.post-content > p').length - 1
    ]
  }
  if (paragraph !== undefined && paragraph !== null) {
    if (campaign.shouldAddSpecificPlaceHolder) {
      paragraph.insertAdjacentHTML(
        campaign.injectPosition,
        `${campaign.specificPlaceHolder}
        ${renderVideoStickToWidget(campaign)}
        `
      )
    } else if (campaign.isSponsoredPost) {
      paragraph.insertAdjacentHTML(
        campaign.injectPosition,
        `<div style='margin: 24px auto; text-align: center;'><iframe class="facts-size" src=${getFactsSrc(
          campaign
        )} scrolling="no"></iframe></div>`
      )
    } else {
      paragraph.insertAdjacentHTML(
        campaign.injectPosition,
        `<div class=${campaign.placeHolder} id=${campaign.id} data-viewability_category="Article page" data-viewability_action="widget viewable impression"
        data-viewability_label=${campaign.name} ${renderDataAttr(campaign)}></div>
        ${renderVideoStickToWidget(campaign)}
        `
      )
    }
  }
}

function injectScript(campaign) {
  if (campaign.id !== 'facts') {
    let script = document.createElement('script')
    script.src = campaign.src
    script.async = true
    if (campaign.id === 'snappdEmbedWidget') {
      script.id = campaign.id
    }
    if (campaign.shouldAddDataAttrToScriptTag) {
      script.setAttribute('data-ark-client', '71c49787-8f2b-4801-b9d7-7f5879a1460d')
      script.setAttribute('data-ark-partner', campaign.publisherDescriptionForGa)
    }
    document.head.appendChild(script)
  }
}

function getFirstLinkStyle() {
  return document.querySelectorAll(
    "p > a[href='https://watch.espnplus.com/sports/?clickid=QfRzfEzooxyJT55xTp3WVUkrUkgSMf2puyk81U0&irgwc=1&ex_cid=DSS-Affiliate-Impact-Content-Minute%20Media-535101']"
  )
}

function getSecLinkStyle() {
  return document.querySelectorAll(
    "p > inline > a[href='http://espn.zlbu.net/c/1386087/535101/9070']"
  )
}

function addNoFollowOnEspnLinks() {
  if (getSite() === '12up') {
    let espnLink = [...getFirstLinkStyle(), ...getSecLinkStyle()]
    if (espnLink.length > 0) {
      espnLink[0].rel = 'nofollow'
    }
  }
}

// function displayVideo(e) {
//   const widgetOrigin = 'https://frontend.playgorithm.net'
//   if (e.origin !== widgetOrigin) {
//     return
//   }
//
//   try {
//     const message = JSON.parse(e.data)
//     switch (message.type) {
//       case 'game-started':
//         break
//       case 'unit-loaded':
//         document.getElementsByClassName('videoWraaperMarketPlace')[0].style.display = 'flex'
//         window.removeEventListener('message', displayVideo)
//         break
//       default:
//         break
//     }
//   } catch (err) {
//     // Non json message, ignore
//   }
// }

function displayVideoTrivia() {
  document.getElementsByClassName('videoWraaperMarketPlace')[0].style.display = 'flex'
}

function adjustPlayerViewability() {
  if (document.getElementsByClassName('videoWraaperMarketPlace')[0] !== undefined) {
    let viewableVideoHeight =
      window.innerHeight -
      document.getElementsByClassName('videoWraaperMarketPlace')[0].getBoundingClientRect().top
    let playerHeight = document
      .getElementsByClassName('videoWraaperMarketPlace')[0]
      .getBoundingClientRect().height
    if (viewableVideoHeight / playerHeight * 100 < 80) {
      window.scrollBy({
        top: playerHeight - viewableVideoHeight,
        left: 0,
        behavior: 'smooth',
      })
    }
  }
}

function listenToFactiveEmmiter() {
  window.__ark_app__ = {
    onload: emitter => {
      // Watch Console for the events
      emitter.on('*', (event, data) => {
        try {
          switch (event) {
            case 'module.moduleVisible':
              document.getElementsByClassName('videoWraaperMarketPlace')[0].style.display = 'flex'
              break
            case 'module.moduleCycleStart':
              adjustPlayerViewability()
              break
            default:
              break
          }
        } catch (err) {
          console.log('error fetch factive events from emiter', err)
        }
      })
    },
  }
}

function loadVideo(src) {
  let s1 = document.createElement('script')
  let s2 = document.createElement('script')
  s1.src = src
  s2.src = 'https://www.oo-syringe.com/prod/injector/injector.1.5.2.js'
  document.body.appendChild(s1)
  document.body.appendChild(s2)
  window.addEventListener('playgorithm-unit-loaded', () => displayVideoTrivia())
  window.addEventListener('playgorithm-game-started', () => adjustPlayerViewability())
  // window.addEventListener('message', displayVideo)
  listenToFactiveEmmiter()
  window.addEventListener('loadedDeepWidget', e => {
    document.getElementsByClassName('videoWraaperMarketPlace')[0].style.display = 'flex'
  })
  window.addEventListener('gameStart', e => {
    adjustPlayerViewability()
  })
}

function loadSyringe() {
  let s1 = document.createElement('script')
  s1.src = 'https://bucket1.mm-syringe.com/prod/injector/injector.1.6.2.js'
  document.body.appendChild(s1)
}

export function injectFreshEight() {
  addNoFollowOnEspnLinks()
  campaigns.forEach(campaign => {
    isCampaignEnabled(campaign).then(response => {
      if (response.isCampaignEnabled && !window.postBodyCampaign) {
        if (campaign.shouldLoadSyringe) {
          loadSyringe()
        }
        addPlaceHolder(campaign)
        injectScript(campaign)
        if (campaign.shouldRenderVideoStick) {
          loadVideo(campaign.videoConfig)
        }
        register('.' + campaign.placeHolder)
      }
    })
  })
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/fresh8/freshEightInjector.js